import { FC } from 'react'
import { ApproveButtonIcon, EditButton, EditButtonIcon } from './styled'
import { TButtonProps } from './types'

const Button: FC<TButtonProps> = ({ width = 36, height = width, onClick, theme }) => {
   return (
      <EditButton onClick={onClick} width={width} height={height} theme={theme}>
         <ApproveButtonIcon />
      </EditButton>
   )
}

export default Button
